// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__j35nw","row":"Dashboard_row__kXi6L","mapContainer":"Dashboard_mapContainer__J41y-","mapResponsive":"Dashboard_mapResponsive__byp0P"};